import React from 'react';
import './App.css';
import Routes from './route';

function App() {
  return (
    <Routes/>
  );
}

export default App;
